export default function getGlobal() {
  try {
    return window // client-side
  } catch (e) {
    return global // server-side
  }
}
